import axios from 'axios';
import type { identifier } from '@core/models/base';
import { axiosToServiceResult } from '@shared/axios';
import type { OrderDisplayModel } from '@shared/models/orders/order';
import type { AddressDisplayModel } from '@shared/models/customer/address';
import type { ServiceSuccess } from '@core/models/actionResponse';
import type { CheckoutClientRequestModel, CheckoutServerModel, CheckoutTotals } from '../models/checkout';

export const saveCheckoutData = async (jobId: identifier, model: CheckoutClientRequestModel) =>
  await axiosToServiceResult(axios.post<CheckoutServerModel>(`/api/customer/jobs/${jobId}/checkout`, model));

export const fetchCheckoutState = async (jobId: identifier) =>
  await axiosToServiceResult(axios.get<CheckoutServerModel>(`/api/customer/jobs/${jobId}/checkout`));

export const fetchCheckoutTotals = async (jobId: identifier) =>
  await axiosToServiceResult(axios.get<CheckoutTotals>(`/api/customer/jobs/${jobId}/checkout/totals`));

export const submitCheckout = async (jobId: identifier) =>
  await axiosToServiceResult(axios.post<OrderDisplayModel>(`/api/customer/jobs/${jobId}/checkout/submit`));

export const fetchCheckoutOrderModel = async (jobId: identifier, orderNumber: string) =>
  await axiosToServiceResult(axios.get<OrderDisplayModel>(`/api/customer/jobs/${jobId}/orders/${orderNumber}`));

export const applyCheckoutPromo = async (jobId: identifier, code: string) =>
  await axiosToServiceResult(axios.post<CheckoutServerModel>(`/api/customer/jobs/${jobId}/checkout/promo`, { code }));

export const removeCheckoutPromo = async (jobId: identifier) =>
  await axiosToServiceResult(axios.delete(`/api/customer/jobs/${jobId}/checkout/promo`));

export const validateShippingAddress = async (jobId: identifier, model: CheckoutClientRequestModel) =>
  await axiosToServiceResult(
    axios.post<AddressDisplayModel[]>(`/api/customer/jobs/${jobId}/checkout/validateaddress`, model),
  );

/**
 * This is a test method to return dummy data for the checkout address validation
 */
export const returnTestData = async (): Promise<ServiceSuccess<AddressDisplayModel[]>> => {
  return {
    data: [
      {
        address1: '3369 Old 63',
        city: 'Columbia',
        province: 'MO',
        postalCode: '65201',
        addresseeName: 'Aaron Harrison',
        country: 'USA',
      } as AddressDisplayModel,
      {
        address1: '3369 Old 63 S',
        city: 'Columbia',
        province: 'MO',
        postalCode: '65201',
        addresseeName: 'Aaron Harrison',
        country: 'USA',
      } as AddressDisplayModel,
    ],
  };
};
